import './employeeQuotes.scss';
import * as React from 'react';
import useEmployeeQuotes from '../../hooks/staticQueries/staff/useEmployeeQuotes';
import Quote from './quote';
export const EmployeeQuotes = () => {
    const { employeeQuotes } = useEmployeeQuotes();
    return (<div className="employee-quotes">
      {employeeQuotes.map((quote, i) => (<Quote key={quote.name + i} quoteText={quote.quote} author={{ name: quote.name, position: quote.role }} image={{ ticket: quote.image[0].ticket, alt: `An image of ${quote.name}` }} expandable/>))}
    </div>);
};
